/**
 * 巡更点
 */
import "./index.less";
import { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import SideBarTool from "@/commons/components/side-bar-tool";
import { SideBarBtnType } from "@/commons/enums/side-bar-btn-type";
import { Storey } from "@/commons/interface/building/storey";
import { StoreyStatus } from "@/commons/context/storey-store";
import { StoreyContext } from "@/App";
import { getComponents } from "@/api/spec-common/component";
import { ComponentType } from "@/commons/enums/component-type";
import { ModelBase, LineType, Layer } from "pytha";
import { graphicStore } from "@/commons/store/graphic-store";
import { BUILDING_SINGAL, BUILDING_SUB_CONTROL, ComponentT, DefaultStoreyUuid, GroupType, PatrolPointT } from "tnbimbase";
import { onActiveSubControl } from "@/commons/utils/graphic-method";
import { Vector3 } from "three";
import { createPrimitive, deletePrimitivesInGraphic, findPrimitivesInGraphic } from "@/api/geometry/primitive";
import { extractFirstNumber } from "@/commons/utils/string-method";
import { Modal, message } from "antd";
import TnModal from "@/commons/widget/base-modal";
import { findLayersInProjectUuid, saveLayer } from "@/api/geometry/layer";
import { LayerType } from "@/commons/enums/layer-type";
import genUUID from '@/commons/utils/gen-uuid';
import { getStoreys } from "@/api/building/storey";
import { SecondaryDropdownBox } from "@/commons/components/secondary-dropdown-box";
import { getModelDetail } from "@/api/project/model";
import { ModelType } from "@/commons/enums/model-file-type";
import { Model } from "@/commons/interface/project/model";



interface IProps {
    width: number
}

export function PatrolPointPanel(props: IProps) {

    const detailRef = useRef(null);

    const { projectUuid, modelUuid } = useParams();
    const storeyContext = useContext<StoreyStatus>(StoreyContext);
    const [patrolEntity, setPatrolEntity] = useState<ModelBase>(); //巡更点组件
    const [storeyList, setStoreyList] = useState<Storey[]>([]);
    const [init, setInit] = useState<boolean>(false);  //防止第一次调用onSelectedChanged的信号时导致面板为空

    const [selectedUuid, setSelectedUuid] = useState<string>("");

    const [maxNumber, setMaxNumber] = useState<number>(0);  //最大巡更点编号

    const [loading, setLoading] = useState<boolean>(false);

    const onChangeSelectedUuid = (v: string) => {
        setSelectedUuid(v);
    }

    const generateData = () => {
        if (!projectUuid || !modelUuid) {
            storeyContext.setStoreys([]);
            return;
        }
        getStoreys(projectUuid, modelUuid).then(res => {
            //为保持全局一致性，不直接从storeyContext中拿，每次都查询后更新
            if (res.status === 200) {
                let data: Storey[] = res.data || [];
                let bottomElevations: number[] = [];

                //按照楼层标高从高到低排序
                data.sort((a, b) => {
                    return - a.bottomElevation + b.bottomElevation;
                });
                data.forEach(item => {
                    bottomElevations.push(item.bottomElevation);
                    item.childList = [];
                });
                storeyContext.setStoreys(data);

                findPrimitivesInGraphic(projectUuid, { type: "PatrolPointT", comType: ComponentType.PATROLPOINT, modelUuids: [modelUuid] }).then(res2 => {
                    if (res2.status === 200) {
                        let primitives = res2.data || [];
                        let tmpMaxNumber = 0;

                        primitives.forEach(element => {
                            //如果有了楼层uuid，则不通过标高计算楼层
                            if (
                                element.properties.group &&
                                element.properties.group[GroupType.STOREY] &&
                                element.properties.group[GroupType.STOREY].length > 0 &&
                                element.properties.group[GroupType.STOREY][0] != DefaultStoreyUuid.DYNAMIC
                            ) {

                                let uuid = element.properties.group[GroupType.STOREY][0];
                                let index = data.findIndex(storey => storey.uuid === uuid);
                                if (index !== -1) {
                                    element.name = element.properties.name;
                                    element.isSelected = false;
                                    let tmpNumber = Number(extractFirstNumber(element.name));
                                    tmpMaxNumber = tmpMaxNumber > tmpNumber ? tmpMaxNumber : tmpNumber;
                                    data[index].childList.push(element);
                                    return;
                                }
                            }
                            let z = element.properties.position.z / 1000;
                            element.name = element.properties.name;
                            element.isSelected = false;
                            let tmpNumber = Number(extractFirstNumber(element.name));
                            tmpMaxNumber = tmpMaxNumber > tmpNumber ? tmpMaxNumber : tmpNumber;
                            let added = false;
                            for (let i = 0; i < bottomElevations.length; i++) {
                                if (z >= bottomElevations[i]) {
                                    data[i].childList.push(element);
                                    added = true;
                                    break;
                                }
                            }
                            if (!added && bottomElevations.length > 0) {
                                //如果标高没有被归类为前面的项，说明低于最低楼层的标高，直接归为最低楼层
                                data[bottomElevations.length - 1].childList.push(element);
                            }
                        });
                        data.forEach(item => {
                            item.nameSuffix = `(${item.bottomElevation}m)\t(已建${item.childList.length}个巡更点)`
                        });
                        setMaxNumber(tmpMaxNumber);
                        setStoreyList(data);
                    }

                })


            }
        }).catch(err => {
            console.log('err', err)
        })

        getComponents({ projectUuid: projectUuid, type: ComponentType.PATROLPOINT }).then(res => {
            if (res.status == 200) {
                let components: any[] = res.data || [];
                if (components.length > 0) {
                    let firstComponent = components[0];
                    let entity: ModelBase = new PatrolPointT().fromJson(firstComponent);
                    setPatrolEntity(entity);
                }
            }
        })
    }

    /**
     * 项目初始化的时候，生成数据
     */
    useEffect(() => {
        generateData();
    }, [projectUuid, modelUuid])

    const onPatrolPointPositionUpdate = (entities: ModelBase[], needDeleted: boolean = false) => {
        let patrolPoints = entities?.filter(entity => entity.type === "PatrolPointT");
        let patrolPointUuidSet = new Set<string>(patrolPoints.map(patrolPoint => patrolPoint.uuid)); //存储被修改后的图元的uuid
        if (patrolPoints.length > 0) {
            let tmpStoreyList = [...storeyList];

            let bottomElevations: number[] = tmpStoreyList.map(storey => storey.bottomElevation);

            //从列表中移除被修改的图元
            tmpStoreyList.forEach(storey => {
                storey.childList = storey.childList.filter(item => !(patrolPointUuidSet.has(item.uuid)));  //filter操作创建新数组，牺牲空间换时间，删除所有被修改的图元
            })

            if (!needDeleted) {//如果需要被删除，就不重新添加进去了
                patrolPoints.forEach((patrolPoint: PatrolPointT) => {
                    if (patrolPoint.group && patrolPoint.group[GroupType.STOREY]?.length > 0 && patrolPoint.group[GroupType.STOREY][0] !== DefaultStoreyUuid.DYNAMIC) {
                        //如果不是动态类型，则将其设置为动态类型
                        patrolPoint.group[GroupType.STOREY][0] = DefaultStoreyUuid.DYNAMIC;
                    }
                    let z = patrolPoint.position.z / 1000;
                    let added = false;
                    for (let i = 0; i < bottomElevations.length; i++) {

                        if (z >= bottomElevations[i]) {
                            let json = patrolPoint.toJson() as any;
                            tmpStoreyList[i].childList.push({ ...json, isSelected: patrolPoint.isSelected });
                            added = true;
                            break;
                        }
                    }
                    if (!added && tmpStoreyList.length > 0) {
                        //如果标高没有被归类为前面的项，说明低于最低楼层的标高，直接归为最低楼层
                        let json = patrolPoint.toJson() as any;
                        tmpStoreyList[bottomElevations.length - 1].childList.push({ ...json, isSelected: patrolPoint.isSelected });
                    }
                })
                tmpStoreyList.forEach(item => {
                    item.nameSuffix = `(${item.bottomElevation}m)\t(已建${item.childList.length}个巡更点)`
                });
            } else {
                //如果是删除模式，只更新每层的巡更点个数
                tmpStoreyList.forEach(item => {
                    item.nameSuffix = `(${item.bottomElevation}m)\t(已建${item.childList.length}个巡更点)`
                });
            }
            setStoreyList(tmpStoreyList);
        }
    }

    /**
     * 巡更点位置修改后的回调，会修改巡更点对应楼层
     */
    useEffect(() => {
        if (graphicStore.extraContext.getCurrentViewEditor()) {
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onEntitiesUpdatePosition.add(onPatrolPointPositionUpdate)
        } else {
            //防止面板被提前打开
            setTimeout(() => {
                if (graphicStore.extraContext.getCurrentViewEditor()) {
                    graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onEntitiesUpdatePosition.add(onPatrolPointPositionUpdate)
                }
            }, 3000);
        }

        return () => {
            if (graphicStore.extraContext.getCurrentViewEditor()) {
                graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onEntitiesUpdatePosition.remove(onPatrolPointPositionUpdate)
            }
        }
    }, [onPatrolPointPositionUpdate])


    const onQuicklyAssembleBlockFinish = (entity: ModelBase) => {
        let tmpNumber = Number(extractFirstNumber(entity.name));
        if (tmpNumber > maxNumber) {
            setMaxNumber(tmpNumber);
            graphicStore.extraContext.getCurrentViewEditor().listeners.getSignal(BUILDING_SINGAL.onQuicklyAssembleBlockChangeName).dispatch(`巡更点${tmpNumber + 1}`)
        }
        let bottomElevations = storeyList.map(item => item.bottomElevation);
        let tmpStoreyList = [...storeyList];
        let added = false;
        let z = (entity as ComponentT).position.z / 1000;
        for (let i = 0; i < bottomElevations.length; i++) {

            if (z >= bottomElevations[i]) {
                let json = (entity as ComponentT).toJson() as any;
                tmpStoreyList[i].childList.push({ ...json, isSelected: entity.isSelected });
                added = true;
                break;
            }
        }
        if (!added && tmpStoreyList.length > 0) {
            //如果标高没有被归类为前面的项，说明低于最低楼层的标高，直接归为最低楼层
            let json = (entity as ComponentT).toJson() as any;
            tmpStoreyList[bottomElevations.length - 1].childList.push({ ...json, isSelected: entity.isSelected });
        }
        tmpStoreyList.forEach(item => {
            item.nameSuffix = `(${item.bottomElevation}m)\t(已建${item.childList.length}个巡更点)`
        });
        setStoreyList(tmpStoreyList);
    }


    /**
     * 巡更点在图形区添加完毕后，在面板上的回调（多显示一行）
     */
    useEffect(() => {
        if (graphicStore.extraContext.getCurrentViewEditor()) {
            graphicStore.extraContext.getCurrentViewEditor().listeners.getSignal(BUILDING_SINGAL.onQuicklyAssembleBlockFinish).add(onQuicklyAssembleBlockFinish)
        } else {
            //防止面板被提前打开
            setTimeout(() => {
                if (graphicStore.extraContext.getCurrentViewEditor()) {
                    graphicStore.extraContext.getCurrentViewEditor().listeners.getSignal(BUILDING_SINGAL.onQuicklyAssembleBlockFinish).add(onQuicklyAssembleBlockFinish)
                }
            }, 3000);
        }

        return () => {
            if (graphicStore.extraContext.getCurrentViewEditor()) {
                graphicStore.extraContext.getCurrentViewEditor().listeners.getSignal(BUILDING_SINGAL.onQuicklyAssembleBlockFinish).remove(onQuicklyAssembleBlockFinish)
            }
        }
    }, [onQuicklyAssembleBlockFinish])


    const onSelectChange = (entities: ModelBase[]) => {
        if (!init) {
            setInit(true);
            return;
        }
        let patrolPoints = entities.filter(item => item instanceof PatrolPointT) as PatrolPointT[];
        let patrolPointdict: { [key: string]: boolean } = {};
        patrolPoints.forEach(patrolPoint => patrolPointdict[patrolPoint.uuid] = patrolPoint.isSelected);
        let tmpStoreyList = [...storeyList];
        for (let i = 0; i < tmpStoreyList.length; i++) {
            let storey = tmpStoreyList[i];
            for (let j = 0; j < storey.childList.length; j++) {
                if (patrolPointdict.hasOwnProperty(storey.childList[j].uuid)) {
                    storey.childList[j].isSelected = patrolPointdict[storey.childList[j].uuid];
                }
            }
        }
        setStoreyList(tmpStoreyList);
    }

    /**
     * 改变图形区选中后，巡更点列表的回调
     */
    useEffect(() => {
        if (graphicStore.extraContext.getCurrentViewEditor()) {
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onSelectChanged.add(onSelectChange)
        } else {
            //防止面板被提前打开
            setTimeout(() => {
                if (graphicStore.extraContext.getCurrentViewEditor()) {
                    graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onSelectChanged.add(onSelectChange)
                }
            }, 3000);
        }

        return () => {
            if (graphicStore.extraContext.getCurrentViewEditor()) {
                graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onSelectChanged.remove(onSelectChange)
            }
        }
    }, [onSelectChange])



    /**
     * 布置巡更点
     */
    const onAddClick = () => {
        setLoading(true);

        let block = patrolEntity.clone();
        let box = block.getBoundingBox();
        let centerPosition = new Vector3();
        box.getCenter(centerPosition);
        centerPosition.setZ(box.min.z);
        let groupKey = []
        getModelDetail(modelUuid).then(res => {
            let model: Model = res.data
            if (model.type != ModelType.SITE) {
                groupKey = [{ key: GroupType.STOREY, value: DefaultStoreyUuid.DYNAMIC }]
            }
            findLayersInProjectUuid(projectUuid, modelUuid).then(res => {
                let layers = res.data || [];
                let layer = layers.find(layer => layer.type === LayerType.PATROL_POINT);
                if (layer) {
                    onActiveSubControl(BUILDING_SUB_CONTROL.QUICKLYASSEMBLEBLOCK.name);
                    graphicStore.extraContext.getCurrentViewEditor()?.listeners.getSignal(BUILDING_SINGAL.onQuicklyAssembleBlock)
                        .dispatch(patrolEntity, centerPosition, layer.uuid, `巡更点${maxNumber + 1}`,
                            groupKey
                        );
                    setLoading(false);
                } else {
                    let uuid = genUUID();
                    let newLayer: Layer = {
                        uuid: uuid,
                        name: "巡更点",
                        color: "#000000",
                        lineWidth: 0.25,
                        lineType: LineType.BASE_LINE,
                        lock: false,
                        hidden: false,
                        originLayer: false,
                        type: LayerType.PATROL_POINT,
                    };
                    saveLayer(newLayer, projectUuid, modelUuid).then(_ => {
                        onActiveSubControl(BUILDING_SUB_CONTROL.QUICKLYASSEMBLEBLOCK.name);
                        console.log('patrolEntity', patrolEntity)
                        graphicStore.extraContext.getCurrentViewEditor()?.listeners.getSignal(BUILDING_SINGAL.onQuicklyAssembleBlock)
                            .dispatch(patrolEntity, centerPosition, uuid, `巡更点${maxNumber + 1}`,
                                groupKey
                            );
                        let newLayers = [...graphicStore.context.layerContext.layers, newLayer];
                        graphicStore.context.layerContext.setLayers(newLayers);  //更新几何库图层
                    }).finally(() => {
                        setLoading(false);
                    })
                }
            }).finally(() => {
                if (loading) {
                    setLoading(false);
                }
            })

        })





    }

    /**
     * 删除巡更点
     * @returns 
     */
    const onDeleteClick = () => {
        let selectedUuids = [];
        let tmpStoreyList = [...storeyList];
        tmpStoreyList.forEach(storey => {
            storey.childList.forEach(item => {
                if (item.isSelected) {
                    selectedUuids.push(item.uuid);
                }
            })
        })
        if (selectedUuids?.length === 0) {
            message.info("未选中巡更点");
            return;
        }
        tmpStoreyList.forEach(storey => {
            storey.childList = storey.childList.filter(item => !item.isSelected);
        })

        TnModal().deleteModal({
            closable: false,
            onOk() {
                deletePrimitivesInGraphic(selectedUuids, projectUuid).then(res => {
                    if (res.status === 200) {
                        message.success("删除成功");
                        setStoreyList(tmpStoreyList);
                        let editor = graphicStore.extraContext.getCurrentViewEditor();
                        if (editor) {
                            editor.removeObjectByUuids(selectedUuids);

                        }
                    }
                }).catch(err => {
                    console.log('err', err)
                }).finally(() => {
                    Modal.destroyAll();
                })
            },
            onCancel() {
                Modal.destroyAll();
            },
        })

    }


    /**
     * 更新巡更点选中状态
     */
    const setSelectedEntity = (uuid: string, selected: boolean) => {
        let tmpStoreyList = [...storeyList];
        for (let i = 0; i < tmpStoreyList.length; i++) {
            let storey = tmpStoreyList[i];
            let has = false;
            for (let j = 0; j < storey.childList.length; j++) {
                if (storey.childList[j].uuid === uuid) {
                    storey.childList[j].isSelected = selected;
                    has = true;
                    break;
                }
            }
            if (has) {
                break;
            }
        }
        setStoreyList(tmpStoreyList);
    }


    /**
     * 更新巡更点名称
     */
    const updateName = (uuid: string, name: string) => {
        let tmpStoreyList = [...storeyList];
        for (let i = 0; i < tmpStoreyList.length; i++) {
            let storey = tmpStoreyList[i];
            let has = false;
            for (let j = 0; j < storey.childList.length; j++) {
                if (storey.childList[j].uuid === uuid) {
                    storey.childList[j].name = name;
                    if ((storey.childList[j] as any).toJson) {
                        createPrimitive((storey.childList[j] as any).toJson());
                    } else {
                        if ((storey.childList[j] as any).properties) {
                            let data = (storey.childList[j] as any).properties
                            data.name = name
                            createPrimitive(data);
                        } else {
                            let data = { ...storey.childList[j] };
                            delete data.isSelected;
                            createPrimitive(data);
                        }
                    }
                    has = true;
                    break;
                }
            }
            if (has) {
                break;
            }
        }
        setStoreyList(tmpStoreyList);
    }






    return (
        // <div>123</div>
        <div className="side-bar-main patrol-point-container">
            <SideBarTool
                activeBtnList={[SideBarBtnType.ADD, SideBarBtnType.DELETE]}
                onAddBtnClick={onAddClick}
                onDeleteBtnClick={onDeleteClick}
                loading={loading}
            />
            <div className="body">
                <div className="title">
                    巡更点
                </div>
                <div className="detail" ref={detailRef}>
                    <SecondaryDropdownBox
                        datas={storeyList}
                        selectedUuid={selectedUuid}
                        onChangeSelectedUuid={onChangeSelectedUuid}
                        setSelectedEntity={setSelectedEntity}
                        updateName={updateName}
                        type="patroPoint"
                        title="巡更点数据集"
                    />

                </div>
            </div >
        </div >
    )

}